module.exports = __webpack_public_path__ + "img/Skirt-Back-B8-Da-Fc.22ed5195.png";